import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Accordion } from '@delmonicos/shared-design-system-react/src/components/accordion/accordion';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ChargePointByTokenTypeCard } from '@app/feature/statistics/charge-point-section/cards/charge-point-by-token-type.card';

export const ChargePointSectionComponent = (): React.JSX.Element => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const renderTitle = () => (
    <AccentTitle
      as={HeadingEnum.H2}
      icon="electric-terminal-3"
      variant={AccentVariantEnum.Accent2}
      text={t('$.statistics.charge-point.title')}
    />
  );

  return (
    <Accordion
      title={renderTitle()}
      isOpen={isOpen}
      onToggle={() => setIsOpen(true)}>
      <ChargePointByTokenTypeCard />
    </Accordion>
  );
};
